import React from 'react';
import Footer from '../Footers/Footer';
import Header from '../Headers/Header';
import { faChevronDown, faMagnifyingGlass, faHouse } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../assests/css/Singlebooking.css';
import mercedes_white from '../../assests/images/mercedes_white.png'

const SingleBookingDetails = () => {
    return (
        <div className='myProfile'>
            <section className='bg-privacy-policy-top mb-5'>
                <Header />
                <div className='container px-5'>
                    <div className='row px-3'>
                        <div className='col-lg-12 my-4 text-center'>
                            <p className='text-white f-72 my-5 f-pop-med'>My Profile</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className='singlebookingdetails my-5'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <p className='f-pop-med f-25 mt-5 mb-5'>Booking Details</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className='card clr-gry'>
                                <div className='card-body'>
                                    <div className='row'>
                                        <div className='col-lg-12'>
                                            <div className='your_details'>
                                                <div className='d-flex justify-content-spacebetween'>
                                                    <p className='f-pop-med f-18'>Your Details</p>
                                                    <FontAwesomeIcon className='f-pop-med f-18' icon={faChevronDown} />
                                                </div>
                                            </div>
                                            <div className='box_other_content '>
                                                <p className='f-pop-med f-18'>Online Booking Details</p>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 mb-5 pe-4'>
                                            <div className='box_other_content '>
                                                <div className='row'>
                                                    <div className='col-sm-6'>
                                                        <p className='f-pop-med f-14 mb-4'>Name :</p>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p className='f-pop-med f-14 clr-64  mb-4'>Lorem Ipsum</p>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p className='f-pop-med f-14  mb-4'>Phone Number :</p>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p className='f-pop-med f-14 clr-64  mb-4'>+000000000000</p>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p className='f-pop-med f-14  mb-4'>Pick Up Date :</p>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p className='f-pop-med f-14 clr-64  mb-4'>04 02 2022</p>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p className='f-pop-med f-14  mb-4'>Pick Up Time :</p>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p className='f-pop-med f-14 clr-64  mb-4'>12:00 AM</p>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p className='f-pop-med f-14  mb-4'>Pick Up Address :</p>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p className='f-pop-med f-14 clr-64  mb-4'>
                                                            Lorem Ipsum is simply dummy text
                                                            of the printing.
                                                        </p>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p className='f-pop-med f-14  mb-4'>Drop Off Address :</p>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p className='f-pop-med f-14 clr-64  mb-4'>
                                                            Lorem Ipsum is simply dummy text
                                                            of the printing.
                                                        </p>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p className='f-pop-med f-14  mb-4'>No. Of Passenger :</p>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p className='f-pop-med f-14 clr-64  mb-4'>
                                                            4 Person
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-6  mb-5 pxsolidblacxk ps-4'>
                                            <div className='box_other_content '>
                                                <div className='row'>
                                                    <div className='col-sm-6'>
                                                        <p className='f-pop-med f-14  mb-4'>No. Of Luggage : :</p>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p className='f-pop-med f-14 clr-64  mb-4'>04</p>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p className='f-pop-med f-14  mb-4'>Vehicle :</p>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <img src={mercedes_white} width={120} />
                                                        <p className='f-pop-med f-14 clr-64  mb-4'>Mercedes Benz</p>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p className='f-pop-med f-14  mb-4'>Driver Note :</p>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p className='f-pop-med f-14 clr-64  mb-4'>Lorem Ipsum is simply dummy text
                                                            of the printing. Lorem Ipsum is simply
                                                            dummy text of the printing.</p>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p className='f-pop-med f-14  mb-4'>Payment Type :</p>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p className='f-pop-med f-14 clr-64  mb-4'>Credit Card</p>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p className='f-pop-med f-14  mb-4 '>Amount :</p>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p className='f-pop-med f-14 clr-64  mb-4'>
                                                            $ 40.00
                                                        </p>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p className='f-pop-med f-14  mb-4'>Flight :</p>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p className='f-pop-med f-14 clr-64 mb-4'>
                                                            Lorem Ipsum is simply dummy text
                                                        </p>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



            </section>
            <Footer />
        </div>
    )
}

export default SingleBookingDetails;